import { render, staticRenderFns } from "./TopFailures.vue?vue&type=template&id=9c8d4c18&"
import script from "./TopFailures.vue?vue&type=script&lang=ts&"
export * from "./TopFailures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports